module.exports = __webpack_public_path__ + "b6edc7ec98110db6f184b3c3938f780d.glb";